// just for test mocking
export const getHostname = () => window.location.hostname;
export const getWindow = () => window;